// import { NavItemType } from 'types/menu';
// import { hasScreenPermission, hasSubScreenPermission } from 'utils/permissionCheck';
// import useAuth from 'hooks/useAuth';

// import purchase from './purchase';
// import widget from './widget';
// import people from './people';
// import product from './product';
// import qcmanagement from './qcmanagement';
// import orders from './orders';
// import campaign from './campaign';
// import inventory from './inventory';
// import users from './users';
// import franchise from './franchise';
// import notification from './notification';
// import flavors from './flavors';

// // ==============================|| CUSTOM HOOK: MENU ITEMS ||============================== //

// const useMenuItems = (): { items: NavItemType[] } => {
//   const { user } = useAuth();
//   const permissions = user?.permissions || [];

//   // Function to filter menu based on screen & sub-screen permissions
//   const filterMenu = (menuGroup: NavItemType): NavItemType | null => {
//     if (!menuGroup.children) return menuGroup;

//     const filteredChildren = menuGroup.children
//       .map((item: any) => {
//         // If parent has submenus (collapse)
//         if (item.children && item.screen_id) {
//           const allowedSubs = item.children.filter((sub: any) =>
//             hasSubScreenPermission(
//               permissions,
//               item.screen_id,
//               sub.sub_screen_id
//             )
//           );

//           // Hide entire collapse menu if no sub items allowed
//           if (allowedSubs.length === 0) return null;

//           return { ...item, children: allowedSubs };
//         }

//         // If item is single screen
//         if (item.screen_id && !hasScreenPermission(permissions, item.screen_id)) {
//           return null;
//         }

//         return item;
//       })
//       .filter(Boolean); // Remove null entries

//     // If group has no visible children → hide it
//     if (filteredChildren.length === 0) return null;

//     return { ...menuGroup, children: filteredChildren };
//   };

//   return {
//     items: [
//       widget,
//       people,
//       product,
//       filterMenu(purchase),
//       filterMenu(qcmanagement),
//       filterMenu(orders),
//       filterMenu(campaign),
//       filterMenu(inventory),
//       filterMenu(users),
//       filterMenu(franchise),
//       filterMenu(notification),
//       filterMenu(flavors)
//     ].filter(Boolean) as NavItemType[]
//   };
// };

// export default useMenuItems;

import { NavItemType } from 'types/menu';
import { hasMenuPermission, hasScreenPermission, hasSubScreenPermission } from 'utils/permissionCheck';
import useAuth from 'hooks/useAuth';

import purchase from './purchase';
import widget from './widget';
import people from './people';
import product from './product';
import qcmanagement from './qcmanagement';
import orders from './orders';
import campaign from './campaign';
import reports from './reports';
import performance from './performance';
import inventory from './inventory';
import users from './users';
import franchise from './franchise';
import notification from './notification';
import company from './company';
import homeScreen from './homeScreen';
import flavors from './flavors';

const useMenuItems = (): { items: NavItemType[] } => {
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const filterMenu = (menuGroup: NavItemType): NavItemType | null => {
    if (!menuGroup.menu_id || !hasMenuPermission(permissions, menuGroup.menu_id)) {
      return null; // No menu permission
    }

    if (!menuGroup.children) return menuGroup;

    const filteredChildren = menuGroup.children
      .map((item: any) => {
        if (item.children && item.screen_id) {
          const allowedSubs = item.children.filter((sub: any) =>
            hasSubScreenPermission(permissions, menuGroup.menu_id, item.screen_id, sub.sub_screen_id)
          );

          if (allowedSubs.length === 0) return null;

          return { ...item, children: allowedSubs };
        }

        if (item.screen_id && !hasScreenPermission(permissions, menuGroup.menu_id, item.screen_id)) {
          return null;
        }

        return item;
      })
      .filter(Boolean);

    if (filteredChildren.length === 0) return null;

    return { ...menuGroup, children: filteredChildren };
  };

  return {
    items: [
      filterMenu(widget),
      filterMenu(people),
      filterMenu(product),
      filterMenu(purchase),
      filterMenu(qcmanagement),
      filterMenu(orders),
      filterMenu(campaign),
      filterMenu(inventory),
      filterMenu(users),
      filterMenu(franchise),
      filterMenu(notification),
      filterMenu(flavors),
      filterMenu(reports),
      filterMenu(performance),
      filterMenu(company),
      filterMenu(homeScreen),
    ].filter(Boolean) as NavItemType[]
  };
};

export default useMenuItems;
